var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      staticClass: "share-resource-popup",
      attrs: { active: _vm.isVisible, title: "Compartilhar recurso" },
      on: {
        "update:active": function($event) {
          _vm.isVisible = $event
        },
        close: _vm.onClose
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "footer-buttons" },
                [
                  _c(
                    "vs-button",
                    { attrs: { type: "border" }, on: { click: _vm.onClose } },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "vs-button",
                    {
                      attrs: { disabled: !_vm.canShare },
                      on: { click: _vm.shareResource }
                    },
                    [_vm._v(" Compartilhar ")]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "share-resource-container" }, [
        _c("div", { staticClass: "resource-info" }, [
          _c(
            "div",
            { staticClass: "icon-container" },
            [
              _c("feather-icon", {
                staticClass: "resource-icon",
                attrs: { icon: _vm.getResourceIcon(), size: "24" }
              })
            ],
            1
          ),
          _c("div", { staticClass: "resource-details" }, [
            _c("h4", [_vm._v(_vm._s(_vm.resourceName))]),
            _c("small", [_vm._v(_vm._s(_vm.resourceType))])
          ])
        ]),
        _c("div", { staticClass: "share-link-section" }, [
          _c("h5", [_vm._v("Link de compartilhamento Público")]),
          _c("div", { staticClass: "share-link-container" }, [
            _c(
              "div",
              { staticClass: "link-wrapper" },
              [
                _vm.shareLink
                  ? _c(
                      "a",
                      {
                        staticClass: "share-link",
                        attrs: {
                          href: _vm.shareLink,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.shareLink) + " ")]
                    )
                  : _c("span", { staticClass: "no-link" }, [
                      _vm._v("Nenhum link disponível")
                    ]),
                _vm.shareLink
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "copy-button",
                        attrs: { type: "border", size: "small" },
                        on: { click: _vm.copyShareLink }
                      },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "CopyIcon", size: "14" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _c("h5", [_vm._v("Compartilhar com")]),
        _c("div", { staticClass: "share-users-section" }, [
          _c(
            "div",
            { staticClass: "users-container" },
            [
              _c("select-suggestion", {
                key: _vm.selectedUser,
                ref: "userSelect",
                attrs: {
                  column: "name,email",
                  model: "User",
                  label: "Usuário",
                  appendClearOption: true,
                  clearAfterSelection: true,
                  placeholderText: "Digite o nome ou e-mail do usuário",
                  itemTextFormat: function(model) {
                    return (
                      model.name +
                      " <br/><div class='text-sm'>" +
                      model.email +
                      "<div>"
                    )
                  }
                },
                on: { "selected-model": _vm.handleUserSelected }
              }),
              _c("div", { staticClass: "selected-items-container" }, [
                _c("div", { staticClass: "selected-items-heading" }, [
                  _c("span", [_vm._v("Usuários selecionados")]),
                  _vm.selectedUsers.length > 0
                    ? _c("small", [
                        _vm._v("(" + _vm._s(_vm.selectedUsers.length) + ")")
                      ])
                    : _vm._e()
                ]),
                _c("div", { staticClass: "selected-items-area" }, [
                  _vm.selectedUsers.length > 0
                    ? _c(
                        "div",
                        { staticClass: "selected-users" },
                        _vm._l(_vm.selectedUsers, function(userObj) {
                          return _c(
                            "div",
                            {
                              key: userObj,
                              staticClass: "selected-user-tag",
                              class: {
                                "is-owner":
                                  _vm.isOwner &&
                                  userObj.id === _vm.currentUser.id
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(userObj.name) + " "),
                                _c("br"),
                                _c("span", { staticClass: "text-sm" }, [
                                  _vm._v(_vm._s(userObj.email))
                                ]),
                                _vm.isOwner && userObj.id === _vm.currentUser.id
                                  ? _c("span", { staticClass: "owner-badge" }, [
                                      _vm._v("Dono")
                                    ])
                                  : _vm._e()
                              ]),
                              !(
                                _vm.isOwner && userObj.id === _vm.currentUser.id
                              )
                                ? _c("feather-icon", {
                                    staticClass: "remove-icon",
                                    attrs: { icon: "TrashIcon", size: "16" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeUser(userObj)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _c("div", { staticClass: "empty-selection" }, [
                        _vm._v(" Nenhum usuário selecionado ")
                      ])
                ])
              ])
            ],
            1
          )
        ]),
        _c("div", { staticClass: "share-groups-section" }, [
          _c(
            "div",
            { staticClass: "groups-container" },
            [
              _c("select-suggestion", {
                key: _vm.selectedGroup,
                ref: "selectedGroup",
                attrs: {
                  column: "name,display_name",
                  model: "Role",
                  label: "Grupos",
                  appendClearOption: true,
                  clearAfterSelection: true,
                  placeholderText: "Digite o nome do grupo",
                  itemTextFormat: function(model) {
                    return "" + model.display_name
                  }
                },
                on: { "selected-model": _vm.handleGroupSelected }
              }),
              _c("div", { staticClass: "selected-items-container" }, [
                _c("div", { staticClass: "selected-items-heading" }, [
                  _c("span", [_vm._v("Grupos selecionados")]),
                  _vm.selectedGroups.length > 0
                    ? _c("small", [
                        _vm._v("(" + _vm._s(_vm.selectedGroups.length) + ")")
                      ])
                    : _vm._e()
                ]),
                _c("div", { staticClass: "selected-items-area" }, [
                  _vm.selectedGroups.length > 0
                    ? _c(
                        "div",
                        { staticClass: "selected-groups" },
                        _vm._l(_vm.selectedGroups, function(groupObj) {
                          return _c(
                            "div",
                            {
                              key: groupObj,
                              staticClass: "selected-group-tag"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " + _vm._s(groupObj.display_name) + " "
                                )
                              ]),
                              _c("feather-icon", {
                                staticClass: "remove-icon",
                                attrs: { icon: "TrashIcon", size: "16" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeGroup(groupObj)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _c("div", { staticClass: "empty-selection" }, [
                        _vm._v(" Nenhum grupo selecionado ")
                      ])
                ])
              ])
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }